/* eslint-disable */

/*
  Functions should return false if invalid, true if valid
*/
export const required = (value) => {
  if (value) {
    return value.length > 0
  }
  return false
}

/**
 * Validate file size
 * @param { NUMBER } fileSizeRaw
 * @param { NUMBER } MAX_FILE_SIZE
 * @returns { Boolean }
 */
export const isFileSizeValid = (fileSizeRaw, MAX_FILE_SIZE) => {
  const fileSize = Math.round(fileSizeRaw / 1000)
  if (fileSize > MAX_FILE_SIZE) return false
  else return true
}

const ALLOWED_IMAGE_EXTENSIONS = ['png', 'apng', 'jpg', 'jpeg']
/**
 * Validate image file
 * Return true if image extension is either png, jpg, jpeg
 * @param {String} filetype
 * @returns {Boolean}
 */
export const isValidImageExtension = (filetype) => {
  if (filetype) {
    const type = filetype.split('/')[0].toLowerCase()
    const extension = filetype.split('/')[1].toLowerCase()

    return ALLOWED_IMAGE_EXTENSIONS.includes(extension) && type === 'image'
      ? true
      : false
  } else {
    return false
  }
}

const ALLOWED_VIDEO_EXTENSIONS = ['mp4']
export const isValidVideoExtension = (filetype) => {
  if (filetype) {
    const type = filetype.split('/')[0].toLowerCase()
    const extension = filetype.split('/')[1].toLowerCase()

    return ALLOWED_VIDEO_EXTENSIONS.includes(extension) && type === 'video'
      ? true
      : false
  } else {
    return false
  }
}

export const validPDF = (filetype) => {
  if (filetype) {
    const type = filetype.split('/')[0].toLowerCase()
    const extension = filetype.split('/')[1].toLowerCase()
    return extension === 'pdf' && type === 'application' ? true : false
  } else {
    return false
  }
}

export const validZIP = (filetype) => {
  // Found on stack overflow: https://stackoverflow.com/questions/6977544/rar-zip-files-mime-type
  const SUPPORTED_TYPES = [
    'application/zip',
    'application/octet-stream',
    'application/x-zip-compressed',
    'multipart/x-zip',
  ]

  if (filetype) {
    return SUPPORTED_TYPES.includes(filetype.toLowerCase()) ? true : false
  } else {
    return false
  }
}

/**
 * @param {String} filename
 * @return {Boolean}
 */
export const validFile = (filename) => {
  const supportedExtensions = [
    'apng',
    'csv',
    'doc',
    'docx',
    'jpeg',
    'jpg',
    'pdf',
    'png',
    'ppt',
    'pptx',
    'ppsx',
    'xls',
    'xlsm',
    'xlsx',
    'zip',
  ]
  if (filename) {
    const splits = filename.split('.')
    const extension = splits.pop().toLowerCase()
    return supportedExtensions.includes(extension)
  } else {
    return false
  }
}
/**
 * is valid url
 * src: https://stackoverflow.com/a/43467144/3888813
 * @param {String}
 * @return {Boolean}
 */
export function isValidURL(string) {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
